module.exports = __webpack_public_path__ + "img/不锈钢通风柜.bf1cc4ab.jpg";